import { AppointmentType, IPatient } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { DoctorDB, HospitalDB, NursingHomeDB, PharmacyDB } from 'src/app/common/repository/databases';

@Injectable({ providedIn: 'root' })
export class InstitutionActivityHelperService {
  constructor() {}

  public getInstitutionDbFromType(appointmentType: AppointmentType): string {
    switch (appointmentType) {
      case 'nursingHome':
        return NursingHomeDB;
      case 'hospital':
        return HospitalDB;
      case 'doctor':
        return DoctorDB;
      case 'pharmacy':
        return PharmacyDB;
    }
  }

  public getInstitutionIdFromPatient(patient: IPatient, appointmentType: AppointmentType): string {
    switch (appointmentType) {
      case 'nursingHome':
        return patient.nursingHomeId;
      case 'hospital':
        return patient.hospital.hospitalId;
      case 'doctor':
        return patient.primaryDoctorId;
      case 'pharmacy':
        return patient.pharmacyId;
    }
  }

  public getInstitutionSearchFieldFromInstitutionType(appointmentType: AppointmentType): string {
    switch (appointmentType) {
      case 'nursingHome':
        return 'nursingHomeId';
      case 'hospital':
        return 'hospital.hospitalId';
      case 'doctor':
        return 'primaryDoctorId';
      case 'pharmacy':
        return 'pharmacyId';
    }
  }

  public getRouteForInstitutionType(appointmentType: AppointmentType): string {
    switch (appointmentType) {
      case 'nursingHome':
        return 'nursing-home';
      case 'hospital':
        return 'hospital';
      case 'doctor':
        return 'doctor';
      case 'pharmacy':
        return 'pharmacy';
    }
  }

  public getAppointmentTypeFromRoute(route: string): AppointmentType {
    switch (route) {
      case 'nursing-home':
        return 'nursingHome';
      case 'hospital':
        return 'hospital';
      case 'doctor':
        return 'doctor';
      case 'pharmacy':
        return 'pharmacy';
    }
  }
}
